import withMainLayout from 'layouts/main';
import dynamic from 'next/dynamic';

// Hero Component import
import PartnersHeroSection from '@/content/partnership-program/main-page/hero-section';

// Dynamic Content Components import
const GlobalReachSection = dynamic(
  () => import('@/content/partnership-program/main-page/global-reach'),
  {
    loading: () => null
  }
);
const FindPartnersSection = dynamic(
  import('@/content/partnership-program/main-page/find-partners'),
  {
    loading: () => null
  }
);
const FaqSection = dynamic(
  () => import('@/content/partnership-program/main-page/faq-section/index'),
  {
    loading: () => null
  }
);
const JoinOurNetworkSection = dynamic(
  import('@/content/partnership-program/shared-components/join-our-network'),
  {
    loading: () => null
  }
);
const PreFooter = dynamic(() => import('@/prefooter'), {
  loading: () => null
});

const seoMetas = {
  title: 'Workable partnerships | Become a Workable partner',
  description:
    'Looking to become a Workable partner? Discover the guidelines, tools and resources you need to join Workable’s partner programs.',
  canonical: 'https://www.workable.com/partnership-program',
  ogimage: 'https://www.workable.com/static/images/workable-partners-social-share.png'
};

const PartnershipProgramPage = () => (
  <>
    <PartnersHeroSection />
    <GlobalReachSection />
    <FindPartnersSection />
    <FaqSection />
    <JoinOurNetworkSection />
    <PreFooter backgroundImg="prefooter-bg-partners.jpg" />
  </>
);

export default withMainLayout(PartnershipProgramPage, {...seoMetas});

export {getSharedPageStaticProps as getStaticProps} from 'helpers/sharedPageStaticProps';
